<template>
    <div class="container-fluid">
        <h5 class="mt-3 mb-3">Kategorie produktów</h5>
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group input-group-sm">
                    <label >Kategoria</label>
                    <select class="form-control select-size" v-model="constraintElementCategoryId">
                        <option v-for="category in categories" :key="category.id" v-bind:value="category.id" >
                            {{ category.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4" v-if="properConstraintSelected">
                <div class="row">
                    <div class="col form-group input-group-sm">
                        <label >Przypisane produkty</label>
                        <vue-tags-input
                            placeholder="Dodaj produkt"
                            :autocomplete-items="productNames"
                            :add-only-from-autocomplete="true"
                            v-model="element"
                            :tags="elements"
                            @tags-changed="elementsChanges"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


import service from '@/components/category-constraints/CategoryConstraintsService'
import alertify from 'alertifyjs'

import VueTagsInput from '@johmun/vue-tags-input';
import un from 'underscore'

export default {
    components: {
        VueTagsInput,
    },
    data() {
        return {
            element: "",
            productNames: [],
            selectedConstraints: {},
            allConstraints: [],
            categories: [],
            constraintElementCategoryId: -1
        }
    },
    watch: {
        "element": "inputTagChange",
        "constraintElementCategoryId": function(categoryId) {
            if (categoryId < 0) {
                return
            }
            var el = un.find(this.allConstraints, (item) => {
                return item.categoryData.id == categoryId
            })
            if (el) {
                this.selectedConstraints = el
            } else {
                this.selectedConstraints = this.createConstraintsNoId(categoryId)
            }
        }
    },
    created() {
        this.loadCategories()
    },
    computed: {
        properConstraintSelected() {
            return this.constraintElementCategoryId > 0
        },
        elements() {
            const arr = this.selectedConstraints.productNames || []
            return un.map(arr, (item) => {
                return {
                    text: item,
                    style: "background-color: #97b84d;"
                }
            })
        }
    },
    methods: {
        loadConstraints() {
            service.fetchConstraints(
                data => { this.allConstraints = data.items; },
                err => { console.log(err) }
            )
        },
        loadCategories() {
            service.fetchAllCategories(
                data => {
                    this.categories = data;
                    this.loadConstraints();
                },
                err => { console.log(err) }
            )
        },
        inputTagChange: un.debounce(function (e) {
            this.initProductNames();
        }, 300),
        initProductNames() {
            if (this.element.length < 2) return;
            service.searchProductNames(
                this.element,
                data => { 
                    this.productNames = un.map(data.items, item => {
                        return {
                            text: item
                        }
                    }); 
                },
                err => { console.log(err) }
            )
        },
        elementsChanges(actualElements) {
            if (actualElements.length == 0) {
                service.deleteConstraints(this.selectedConstraints.id,
                    (_) => { 
                        this.selectedConstraints = this.createConstraintsNoId(this.constraintElementCategoryId);
                        this.loadConstraints()
                    },
                    (err) => { console.log(err) }
                )
            } else {
                this.persisConstraints(actualElements)
            }
        },
        persisConstraints(actualElements) {
            const constraintsData = {
                "categoryId": this.constraintElementCategoryId,
                "productNames": un.map(actualElements, item => { return item.text })
            }
            if (this.selectedConstraints.id) {
                constraintsData["id"] = this.selectedConstraints.id
            }
            service.saveConstraints(constraintsData,
                data => { 
                    this.selectedConstraints = data.item
                    var element = un.findWhere(this.allConstraints, { id: this.selectedConstraints.id })
                    if (element) {
                        this.allConstraints = un.without(this.allConstraints, element)
                    }
                    this.allConstraints.push(this.selectedConstraints)
                },
                err => { console.log(err) }
            )
        },
        itemLabel(constraintElement) {
            const maxLetters = 70
            const label = constraintElement.productNames.join()
            return label.length > maxLetters ? label.slice(0, maxLetters) + "..." : label
        },
        createConstraintsNoId(categoryId) {
            return {
                productNames: [],
                categoryData: {
                    id: categoryId
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .torre-green-btn {
        background-color: #97b84d;
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 5px 6px;
        font-size: 12px;
        line-height: 1.42;
        border-radius: 15px;
        margin-bottom: 10px;
        &:hover{
            background-color: #a5d143;
        }
        .material-icons {
            color: white;
            vertical-align: middle;
            padding-right: 10px;
            font-size: 16px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/category-constraints/CategoryConstraints.vue